const HistorizationChartEntity = (backClient) => ({
  chart: async () => await backClient.get("/api/analyze/history"),
})

export default HistorizationChartEntity
